module.exports = __webpack_public_path__ + "convite/assets/img/google-play-badge.445ecd84.png";